export interface ISettingsNotificationsResponse {
  notification: ISettingsNotificationConfig;
}

export interface ISettingsNotificationsPayload {
  namespace: SettingsNotificationsNamespace;
}

export enum ESettingsNotificationsFormField {
  NAMESPACE = 'namespace',
  LOCALE = 'locale',
  HEADER_COLOR = 'header_color',
  TEXT_COLOR = 'text_color',
  BODY = 'body',
  VISIBLE = 'visible',
}

export interface ISettingsNotificationsForm {
  [ESettingsNotificationsFormField.NAMESPACE]: SettingsNotificationsNamespace;
  [ESettingsNotificationsFormField.LOCALE]: string;
  [ESettingsNotificationsFormField.HEADER_COLOR]: string;
  [ESettingsNotificationsFormField.TEXT_COLOR]: string;
  [ESettingsNotificationsFormField.BODY]: string;
  [ESettingsNotificationsFormField.VISIBLE]: boolean;
}

export interface ISettingsNotificationsSavePayload {
  notification: ISettingsNotificationConfig;
  namespace: SettingsNotificationsNamespace;
  merchant: number;
}

export interface ISettingsNotificationConfig {
  id?: number;
  header_color: string;
  text_color: string;
  visible: boolean;
  text_for_notifications_attributes: ISettingsNotificationsItem[];
}

export interface ISettingsNotificationsItem {
  id?: number;
  body: string;
  locale: string;
}

export enum ESettingsNotificationsNamespace {
  ANONYMOUS = 'anonym',
  AFFILIATE = 'affiliate',
}

export type SettingsNotificationsNamespace =
  | ESettingsNotificationsNamespace.AFFILIATE
  | ESettingsNotificationsNamespace.ANONYMOUS;
